module.exports = __webpack_public_path__ + "static/img/anxun51.df5205d1.png";